import type { FormState, ProfileSummaryOut } from "@/api/generated/Api";
import type { ProfileMeta, ProfileStatus } from "./types";

const PROFILE_STATUS_BY_FORM_STATE: Record<FormState, ProfileStatus> = {
  not_started: "not_started",
  processing: "processing",
  completed: "success",
  failed: "error",
};

export function toProfileStatus(state: FormState): ProfileStatus | undefined {
  return PROFILE_STATUS_BY_FORM_STATE[state];
}

export function mergeProfileMeta(
  existing: ProfileMeta,
  summary: ProfileSummaryOut,
): ProfileMeta {
  const reported = toProfileStatus(summary.status);
  const startingLocally =
    existing.isCreating === true && reported === "not_started";
  const status = startingLocally ? existing.status : reported;

  return {
    ...existing,
    isInDatabase: true,
    isRoleplay: summary.is_roleplay ?? false,
    ...(status === "processing" || status === "error"
      ? { isTrackingStatus: true }
      : {}),
    ...(status ? { status } : {}),
    ...(summary.task_id ? { taskId: summary.task_id } : {}),
    ...(summary.phone ? { telephone: summary.phone } : {}),
    ...(summary.status === "failed" && summary.error
      ? { errorMessage: summary.error }
      : {}),
  };
}

function isUsablePhone(phone: string): boolean {
  const digits = phone.replace(/\D/g, "");
  return digits.length >= 10 && !/^0+$/.test(digits.slice(-10));
}

/** Телефон именно открытого профиля: анкета, иначе meta. */
export function telephoneFromOpenProfile(
  meta: ProfileMeta | undefined,
): string | undefined {
  const forms = meta?.profileData?.forms;
  if (forms?.length) {
    for (let i = forms.length - 1; i >= 0; i -= 1) {
      const phone = forms[i]?.telephone?.trim();
      if (phone && isUsablePhone(phone)) return phone;
    }
  }
  const metaPhone = meta?.telephone?.trim();
  return metaPhone || undefined;
}
